<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-decimal-field
    #fieldComponent
    [form-control]="formControl"
    [field]="cellParams.field"
  ></app-decimal-field>
</div>
